import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import LessonPlanItem, { LessonPlanItemDTO } from '@/models/LessonPlanItem';
import { BaseFilters } from '@/models/Service';

const BASE_URL = 'lesson-plan-items';

export type ListLessonPlanItemFilters = BaseFilters & {
  lessonPlanId?: number[];
  assessmentItemId?: number;
  isEvaluation?: boolean;
};

export type CreateLessonPlanItemBody = LessonPlanItemDTO & {
  lessonPlanId: number;
};

export const listLessonPlanItems = async (
  filters: ListLessonPlanItemFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<LessonPlanItem>>(
    `${BASE_URL}/`,
    { params: filters },
  );
  return data;
};

export const createLessonPlanItem = async (body: CreateLessonPlanItemBody) => {
  const { data } = await requester().post<LessonPlanItem>(`${BASE_URL}/`, body);
  return data;
};

export const updateLessonPlanItem = async (
  lessonPlanItemId: number,
  body: Partial<LessonPlanItemDTO>,
) => {
  const { data } = await requester().patch<LessonPlanItem>(
    `${BASE_URL}/${lessonPlanItemId}/`,
    body,
  );
  return data;
};

export const removeLessonPlanItem = async (lessonPlanItemId: number) => {
  await requester().delete<void>(`${BASE_URL}/${lessonPlanItemId}/`);
};
